import { citrusStyled } from '@citrus/runtime';
import { arrow, body, bodyWithClose, bodyMenu, bodyUtility, focusTrapInnerContainer, footer, flyout, header, headerButtonContainer, headerText, headerTextWrapper, menu, menuWithHeader, menuItem, menuItemDisabled, subHeaderText, wrapper, } from '../styles/legacy';
import { arrow as arrowCitron, body as bodyCitron, bodyWithClose as bodyWithCloseCitron, bodyHeader, bodyMenu as bodyMenuCitron, bodyUtility as bodyUtilityCitron, focusTrapInnerContainer as focusTrapInnerContainerCitron, footer as footerCitron, flyout as flyoutCitron, flyoutMenu, header as headerCitron, headerButtonContainer as headerButtonContainerCitron, headerText as headerTextCitron, headerTextWrapper as headerTextWrapperCitron, menu as menuCitron, menuWithHeader as menuWithHeaderCitron, menuItem as menuItemCitron, menuItemDisabled as menuItemDisabledCitron, subHeaderText as subHeaderTextCitron, wrapper as wrapperCitron, } from '../styles/citron';
export var Arrow = citrusStyled.div('arrow', { legacy: arrow, citrus2022: arrowCitron });
export var Flyout = citrusStyled.div('flyout', { legacy: flyout, citrus2022: flyoutCitron });
export var FlyoutMenu = citrusStyled.div('flyoutMenu', { citrus2022: flyoutMenu });
export var FocusTrapRoot = citrusStyled.div('N/A', null);
export var FocusTrapInnerContainer = citrusStyled.div('focusTrapInnerContainer', {
    legacy: focusTrapInnerContainer,
    citrus2022: focusTrapInnerContainerCitron,
});
export var Menu = citrusStyled.div('menu', { legacy: menu, citrus2022: menuCitron });
export var MenuWithHeader = citrusStyled.div('menuWithHeader', {
    legacy: menuWithHeader,
    citrus2022: menuWithHeaderCitron,
});
export var MenuItem = citrusStyled.button('menuItem', { legacy: menuItem, citrus2022: menuItemCitron });
export var MenuItemDisabled = citrusStyled.button('menuItemDisabled', {
    legacy: menuItemDisabled,
    citrus2022: menuItemDisabledCitron,
});
export var Wrapper = citrusStyled.div('wrapper', { legacy: wrapper, citrus2022: wrapperCitron });
export var Header = citrusStyled.div('header', { legacy: header, citrus2022: headerCitron });
export var HeaderButtonContainer = citrusStyled.div('headerButtonContainer', {
    legacy: headerButtonContainer,
    citrus2022: headerButtonContainerCitron,
});
export var HeaderText = citrusStyled.h2('headerText', { legacy: headerText, citrus2022: headerTextCitron });
export var HeaderTextWrapper = citrusStyled.div('headerTextWrapper', {
    legacy: headerTextWrapper,
    citrus2022: headerTextWrapperCitron,
});
export var SubHeaderText = citrusStyled.h4('subHeaderText', {
    legacy: subHeaderText,
    citrus2022: subHeaderTextCitron,
});
export var Body = citrusStyled.div('body', { legacy: body, citrus2022: bodyCitron });
export var BodyWithClose = citrusStyled.div('bodyWithClose', {
    legacy: bodyWithClose,
    citrus2022: bodyWithCloseCitron,
});
export var BodyHeader = citrusStyled.div('bodyHeader', { citrus2022: bodyHeader });
export var BodyMenu = citrusStyled.div('bodyMenu', { legacy: bodyMenu, citrus2022: bodyMenuCitron });
export var BodyUtility = citrusStyled.div('bodyUtility', { legacy: bodyUtility, citrus2022: bodyUtilityCitron });
export var Footer = citrusStyled.div('footer', { legacy: footer, citrus2022: footerCitron });
export var Styled = {
    Arrow: Arrow,
    Body: Body,
    BodyWithClose: BodyWithClose,
    BodyHeader: BodyHeader,
    BodyMenu: BodyMenu,
    BodyUtility: BodyUtility,
    Footer: Footer,
    Flyout: Flyout,
    FlyoutMenu: FlyoutMenu,
    FocusTrapRoot: FocusTrapRoot,
    FocusTrapInnerContainer: FocusTrapInnerContainer,
    Header: Header,
    HeaderButtonContainer: HeaderButtonContainer,
    HeaderText: HeaderText,
    HeaderTextWrapper: HeaderTextWrapper,
    Menu: Menu,
    MenuWithHeader: MenuWithHeader,
    MenuItem: MenuItem,
    MenuItemDisabled: MenuItemDisabled,
    SubHeaderText: SubHeaderText,
    Wrapper: Wrapper,
};
